import { format } from 'date-fns'
import es from 'date-fns/locale/es'
import moneyFormat from 'utils/dinero'
import { ACT_TYPES } from 'constants/activities'
import { CREDIT_TYPES } from 'constants/credit'

const {
  BANK_TRANSFER_IN,
  BANK_TRANSFER_OUT,
  MANUAL_MOVEMENT,
  CARD_PURCHASE,
  EXTRACASH,
  EXTRACASH_TYPE
} = ACT_TYPES
const { ZERO_RATE, DEFAULT } = CREDIT_TYPES

// Gets the specific props needed for MovementsItem component
//
export function getMovementListProperties(act) {
  let props = {
    balance: act.entry_type === 'CREDIT',
    id: act.id
  }
  switch (act.type_original) {
    case BANK_TRANSFER_OUT:
      props = {
        ...props,
        firstText: act.type,
        secondText: act.data.properties.destination_holder_name,
        amount: act.total_amount,
        result: act.result,
        date: format(new Date(act.created_at), 'dd/MM/yy', {
          locale: es
        })
      }
      break
    case BANK_TRANSFER_IN:
      props = {
        ...props,
        firstText: act.type,
        secondText: act.data.properties.source_holder_name,
        amount: act.total_amount,
        result: act.result,
        date: format(new Date(act.created_at), 'dd/MM/yy', {
          locale: es
        })
      }
      break
    case MANUAL_MOVEMENT:
      props = {
        ...props,
        secondText: act.entry_type === 'CREDIT' ? 'Crédito' : 'Débito',
        firstText: getManualMovementType(act),
        amount: act.total_amount,
        date: format(new Date(act.created_at), 'dd/MM/yy', {
          locale: es
        })
      }
      break
    case CARD_PURCHASE:
      props = {
        ...props,
        firstText: act.type,
        secondText: act.data.properties.merchant_name,
        amount: act.total_amount,
        result: act.result,
        date: format(new Date(act.created_at), 'dd/MM/yy', {
          locale: es
        })
      }
      break
    case EXTRACASH:
      props = {
        ...props,
        firstText: 'Compra con extracción',
        secondText: act.data.properties.merchant_name,
        amount: act.total_amount,
        result: act?.result,
        date: format(new Date(act.created_at), 'dd/MM/yy', {
          locale: es
        })
      }
      break
    default:
      throw new Error()
  }
  return props
}

// Gets the specific props needed for Activity details
export function getActivityDetailsByType(act, cvu) {
  let props = {
    slug: act.type,
    id: act.id
  }

  switch (act.type) {
    case BANK_TRANSFER_OUT:
      props = {
        ...props,
        type: 'Transferencia enviada',
        title: act.data.properties.destination_holder_name,
        amount: moneyFormat(act.total_amount),
        items: {
          origen: cvu,
          destino: act.data.properties.destination_address,
          banco: act.data.properties.destination_bank_name,
          fecha: format(new Date(act.created_at), 'dd/MM/yy', {
            locale: es
          }),
          detalle: act.data.description
        }
      }
      break
    case BANK_TRANSFER_IN:
      props = {
        ...props,
        type: 'Transferencia recibida',
        title: act.data.properties.source_holder_name,
        amount: moneyFormat(act.total_amount),
        items: {
          origen: act.data.properties.source_address,
          destino: cvu,
          banco: act.data.properties.source_bank_name || '',
          fecha: format(new Date(act.created_at), 'dd/MM/yy', {
            locale: es
          })
        }
      }
      break
    case MANUAL_MOVEMENT:
      props = {
        ...props,
        entryType: act.entry_type,
        amount: moneyFormat(act.total_amount),
        title: getManualMovementType(act),
        isAdvance:
          act.entry_type === 'CREDIT' &&
          (act.data.metadata?.type === DEFAULT ||
            act.data.metadata?.type === ZERO_RATE),
        isCashbackRefund:
          act.entry_type === 'CREDIT' &&
          act.data?.metadata?.type === 'cashback',
        isCashbackCancellation:
          act.entry_type === 'DEBIT' && act.data?.metadata?.type === 'cashback',
        items: {
          fecha: format(new Date(act.created_at), 'dd/MM/yy', {
            locale: es
          }),
          detalle:
            act.entry_type === 'DEBIT' &&
            (act.data.metadata?.type === DEFAULT ||
              act.data.metadata?.type === ZERO_RATE) &&
            act.data.description
        }
      }
      break
    case CARD_PURCHASE:
      props = {
        ...props,
        title: act.data.properties.merchant_name,
        amount: moneyFormat(act.total_amount),
        type: 'Compra con tarjeta',
        items: {
          tarjeta: `${act.data.properties.card_brand} **** **** **** ${act.data.properties.last_digits}`,
          fecha: format(new Date(act.created_at), 'dd/MM/yy', {
            locale: es
          })
        }
      }
      break
    case EXTRACASH_TYPE:
      props = {
        ...props,
        title: act.data.properties.merchant_name,
        amount: moneyFormat(act.total_amount),
        type: 'Compra con extracción',
        items: {
          tarjeta: `${act.data.properties.card_brand} **** **** **** ${act.data.properties.last_digits}`,
          fecha: format(new Date(act.created_at), 'dd/MM/yy', {
            locale: es
          })
        }
      }
      break
    default:
      throw new Error()
  }
  return props
}

// get type of movement
function getManualMovementType(mov) {
  if (mov.entry_type === 'CREDIT') {
    if (
      mov.data?.metadata?.type === DEFAULT ||
      mov.data?.metadata?.type === ZERO_RATE
    ) {
      return 'Adelanto Wayni'
    }
    if (mov.data?.metadata?.type === 'cashback') {
      return 'Reintegro'
    }
    return 'Crédito manual'
  }

  if (mov.entry_type === 'DEBIT') {
    if (mov.data?.metadata?.type === 'cashback') {
      return 'Anulación de reintegro'
    }
  }

  return 'Débito manual'
}
